import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  Badge,
} from "flowbite-react";
import { useState, useEffect } from "react";

const statusColors = {
  Initial: "gray",
  Started: "yellow",
  Completed: "green",
};

export default function JobTable({ jobs, setEid, opModal, onViewItems, onViewExpenses }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(jobs);
  }, [jobs]);

  return (
    <div className="overflow-x-auto rounded-lg border-2 border-white shadow-sm">
      <Table striped hoverable>
        <TableHead className="bg-gray-800">
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Job Name
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Description
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Client
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Status
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Start Date
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            End Date
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            <span className="sr-only">Actions</span>
          </TableHeadCell>
        </TableHead>

        <TableBody className="divide-y divide-gray-700">
          {data.map((job, index) => (
            <TableRow
              key={job.id}
              className={`${
                index % 2 === 0 ? "bg-gray-800" : "bg-gray-900"
              } hover:bg-gray-700 transition-colors`}
            >
              <TableCell className="whitespace-nowrap font-medium text-white">
                {job.j_name}
              </TableCell>
              <TableCell className="text-gray-300 max-w-xs">
                {job.description || "-"}
              </TableCell>
              <TableCell className="text-gray-300">{job.c_name}</TableCell>
              <TableCell>
                <Badge color={statusColors[job.status] || "gray"}>
                  {job.status || "Initial"}
                </Badge>
              </TableCell>
              <TableCell className="text-gray-300">
                {job.s_date ? job.s_date.split("T")[0] : "-"}
              </TableCell>
              <TableCell className="text-gray-300">
                {job.e_date ? job.e_date.split("T")[0] : "-"}
              </TableCell>
              <TableCell>
                <div className="flex gap-1 flex-wrap">
                  <Button size="xs" color="blue" onClick={() => onViewItems(job)}>
                    Items
                  </Button>
                  <Button size="xs" color="purple" onClick={() => onViewExpenses(job)}>
                    Expenses
                  </Button>
                  <Button
                    size="xs"
                    color="gray"
                    onClick={() => {
                      setEid(job.id);
                      opModal();
                    }}
                  >
                    Edit
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}

          {data.length === 0 && (
            <TableRow>
              <TableCell colSpan={7} className="text-center py-8 text-gray-400">
                No jobs found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
